// Tetos de anexos aplicados no backend (SC-10805). Mantidos aqui para o upload já
// barrar no navegador, com a mesma regra que a API valida.

// Comprovantes por despesa em Contas a Pagar.
export const MAX_RECEIPTS = 3

// Comprovantes por entrada em Contas a Receber. Era 1 (has_one) até o OtherRevenue passar
// a espelhar o contas a pagar; bate com OtherRevenue::MAX_DOCUMENT_FILES.
export const MAX_REVENUE_RECEIPTS = 3

// Anexos por cobrança.
export const MAX_BILLING_DOCUMENTS = 3
